import { graphql } from "gatsby"
import { withPrismicPreview } from "gatsby-plugin-prismic-previews"

import { AboutPageTemplate } from "../templates/AboutPageTemplate"
import linkResolver from "../utils/linkResolver"

export const query = graphql`
  query AboutPageTemplate {
    prismicAboutPage {
      _previewable
      type
      uid
      data {
        masthead_background {
          gatsbyImageData(width: 1920, placeholder: BLURRED)
          thumbnails {
            mobile_portrait {
              gatsbyImageData(width: 420, placeholder: BLURRED)
            }
            mobile_landscape {
              gatsbyImageData(width: 900, placeholder: BLURRED)
            }
          }
        }
        title {
          text
        }
        description {
          richText
        }
        meta_title
        meta_description
        language
        canonical_url {
          url
        }
        opengraph_image {
          url
        }
      }
    }
  }
`
export default withPrismicPreview(AboutPageTemplate, [
  {
    repositoryName: process.env.GATSBY_PRISMIC_REPO_NAME,
    linkResolver,
  },
])
